import { useAuthStore } from '@/stores/useAuthStore.ts'

function loadPersistedToken() {
  const authStore = useAuthStore()
  authStore.loadPersistedToken()
}

export { loadPersistedToken }
